import React, { useEffect, useRef, useState } from "react";
import "./Left_Tabs.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Dropdown } from "react-bootstrap";
import Logout_Modal from "../../common-components/common-modals/logout_modal/Logout_Modal";

const Left_Tabs = (props) => {
  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const navigate = useNavigate("");
  const [activeTab, setActiveTab] = useState(0);
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [expandedTabIndex, setExpandedTabIndex] = useState(null);

  const tabs = [
    {
      tab_label: "Personal Details",
      img: "/assets/images/my_account/img1.png",
    },
    {
      tab_label: "Order History",
      img: "/assets/images/my_account/img2.png",
      subTabs: [
        {
          inner_tab: "In-Transit",
          inner_img: "/assets/images/my_account/img3.png",
        },
        {
          inner_tab: "Delivered",
          inner_img: "/assets/images/my_account/img4.png",
        },
        // {
        //   inner_tab: "Returned",
        //   inner_img: "/assets/images/my_account/img5.png",
        // },
        // {
        //   inner_tab: "Canceled",
        //   inner_img: "/assets/images/my_account/img6.png",
        // },
      ],
    },
    {
      tab_label: "Prescriptions",
      img: "/assets/images/my_account/img7.png",
    },
    // {
    //   tab_label: "Appointments",
    //   img: "/assets/images/my_account/img8.png",
    // },
    {
      tab_label: "Rewards",
      img: "/assets/images/my_account/img9.png",
    },
    {
      tab_label: "Logout",
      img: "/assets/images/my_account/img11.png",
    },
  ];

  useEffect(() => {
    const ordersTab = tabs.find((tab) => tab.tab_label === "Order History");
    const index = tabs.findIndex((tab) => tab.tab_label === "Order History");

    if (activeTab === index && ordersTab?.subTabs?.length > 0) {
      const isValidSubTab = ordersTab.subTabs.some(
        (sub) => sub.inner_tab === activeSubTab?.inner_tab
      );
      if (!isValidSubTab) {
        const defaultSubTab = ordersTab.subTabs[0];
        setActiveSubTab(defaultSubTab);
        props?.setSelectedTab(defaultSubTab.inner_tab);
      }
    }
  }, [activeTab]);

  const toggleExpand = (index) => {
    setExpandedTabIndex((prev) => (prev === index ? null : index));
  };

  const [expandedTab, setExpandedTab] = useState(null);

  const getActiveTabLabel = () => {
    const [mainIndex, subIndex] = `${activeTab}`.split("-");
    const tab = tabs[mainIndex];

    if (tab?.subTabs && subIndex !== undefined) {
      const subTab = tab.subTabs[subIndex];
      return {
        label: subTab?.inner_tab,
        img: subTab?.inner_img,
      };
    }

    return {
      label: tab?.tab_label || "Select Tab",
      img: tab?.img || null,
    };
  };

  const activeTabData = getActiveTabLabel();

  return (
    <section className="Left_Tabs">
      <div className="desktop_sidebar">
        <div className="title_div">
          <p className="title_text">My Account</p>
        </div>

        {tabs.map((item, index) => {
          const isMainActive = activeTab === index;
          const hasSubTabs = item.subTabs?.length > 0;
          const isExpanded = expandedTabIndex === index;

          return (
            <>
              <div
                className={`tabs_main_div ${
                  isMainActive ? "active red_bg_div" : "blue_bg_div"
                }`}
                onClick={() => {
    if (item?.tab_label === "Logout") {
      setshowLogoutModal(true);
      return;
    }

    if (!hasSubTabs) {
      setActiveTab(index);
      setActiveSubTab(null);
      props?.setSelectedTab(item?.tab_label);
      setExpandedTabIndex(null);
    } else {
      setActiveTab(index);

      if (expandedTabIndex === index) {
        // ✅ Toggle close
        setExpandedTabIndex(null);
      } else {
        // ✅ Toggle open
        setExpandedTabIndex(index);
      }
    }
  }}
              >
                <div className="text_holder">
                  <div className="left_side">
                    <div className="icon_holder">
                      <img src={item?.img} className="icon_img" />
                    </div>
                    <p className="tab_name">{item?.tab_label}</p>
                  </div>

                  {hasSubTabs && (
                    <span className="icon">
                      {isExpanded ? (
                        <FontAwesomeIcon icon={faSortUp} />
                      ) : (
                        <FontAwesomeIcon icon={faSortDown} />
                      )}
                    </span>
                  )}
                </div>
              </div>

              {expandedTabIndex === index && hasSubTabs && (
                <div className="inner_tabs">
                  {item.subTabs.map((subTab, subIndex) => (
                    <div
                      key={subIndex}
                      className={`inner_tab ${
                        activeSubTab?.inner_tab === subTab.inner_tab
                          ? "active-sub-tab"
                          : "blue_bg_div"
                      }`}
                      onClick={() => {
                        setActiveSubTab(subTab);
                        props?.setSelectedTab(subTab.inner_tab);
                      }}
                    >
                      <div className="icon_holder">
                        <img src={subTab?.inner_img} className="icon_img" />
                      </div>
                      <p className="tab_name">{subTab.inner_tab}</p>
                    </div>
                  ))}
                </div>
              )}
            </>
          );
        })}
      </div>

      <div className="mobile_div">
        <Dropdown>
          <Dropdown.Toggle
            className="tabs_main_div active dropdown_button"
            id="tab-dropdown"
          >
            <div className="text_holder">
              {activeTabData?.img && (
                <div className="tab_icon_holder">
                  <img
                    src={activeTabData.img}
                    alt={activeTabData.label}
                    className="tab_icon"
                  />
                </div>
              )}
              <p className="tab_name">{activeTabData.label}</p>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {tabs.map((value, index) => {
              const isMainActive =
                activeTab === index ||
                (typeof activeTab === "string" &&
                  activeTab.startsWith(`${index}-`));

              return (
                <React.Fragment key={index}>
                  <Dropdown.Item
                    as="div"
                    onClick={(e) => {
                      if (value?.tab_label === "Order History") {
                        e.stopPropagation(); // Prevent closing only for Order History
                      }
                    }}
                  >
                    <div
                      className={`tabs_main_div ${
                        isMainActive ? "active red_bg_div" : "blue_bg_div"
                      }`}
                      onClick={() => {
                        if (
                          value?.tab_label === "Order History" &&
                          value?.subTabs
                        ) {
                          const isFirstClick = expandedTab !== index;

                          setExpandedTab(isFirstClick ? index : null);
                          // if (isFirstClick) {
                          //   setActiveTab(index);
                          //   props?.setSelectedTab(value?.tab_label);
                          // }
                        } else if (value?.tab_label === "Logout") {
                          setshowLogoutModal(true);
                        } else {
                          setActiveTab(index);
                          props?.setSelectedTab(value?.tab_label);
                          setExpandedTab(null); // collapse any open submenu
                        }
                      }}
                    >
                      <div className="left_side">
                        <div className="icon_holder">
                          <img src={value?.img} className="icon_img" />
                        </div>
                        <p className="tab_name">{value?.tab_label}</p>
                      </div>
                    </div>
                  </Dropdown.Item>

                  {/* SubTabs */}
                  {expandedTab === index && value?.subTabs && (
                    <div className="subtabs_container">
                      {value.subTabs.map((subTab, subIndex) => {
                        const subTabKey = `${index}-${subIndex}`;
                        const isSubActive = activeTab === subTabKey;

                        return (
                          <Dropdown.Item as="div" key={subTabKey}>
                            <div
                              className={`tabs_main_div ${
                                isSubActive
                                  ? "active red_bg_div"
                                  : "blue_bg_div"
                              }`}
                              onClick={() => {
                                setActiveTab(subTabKey);
                                setActiveSubTab(subTab); // <-- optional: track selected subtab object
                                props?.setSelectedTab(subTab.inner_tab); // Use inner_tab string
                                setExpandedTab(null); // Close submenu
                              }}
                            >
                              <div className="text_holder">
                                <div className="icon_holder">
                                  <img
                                    src={subTab?.inner_img}
                                    className="icon_img"
                                  />
                                </div>
                                <p className="tab_name">{subTab.inner_tab}</p>
                              </div>
                            </div>
                          </Dropdown.Item>
                        );
                      })}
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <Logout_Modal
        show={showLogoutModal}
        onHide={() => setshowLogoutModal(false)}
        questionText="Are you sure you want to logout?"
      />
    </section>
  );
};

export default Left_Tabs;
